import React from 'react';
import { motion } from 'framer-motion';
import { Link2Icon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-36 pb-16 sm:pt-36 sm:pb-20 lg:pt-44 lg:pb-28 overflow-hidden" data-id="element-97" data-mp="2hvm3g5hi9ga4">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10" data-id="element-98" data-mp="23x4mqrq0p41p">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-full bg-kitty-yellow-100/40 blur-3xl" data-id="element-99" data-mp="28ueiep402bxz" />
        <div className="absolute top-[40%] -left-[10%] w-[50%] h-[50%] rounded-full bg-blue-50/40 blur-3xl" data-id="element-100" data-mp="2wm343mmbg25y" />
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-8" data-id="element-101" data-mp="2mu5om3o9yo1f">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-10 items-center" data-id="element-102" data-mp="2mrtc461ad5vr">
          {/* Left Column */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="max-w-xl" data-id="element-103" data-mp="2rqw8l237a3s4">
            {/* Badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.1,
            duration: 0.4
          }} className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-kitty-yellow-100 text-kitty-yellow-800 font-medium text-xs sm:text-sm mb-6 lg:mb-8" data-id="element-104" data-mp="2ff0ewur5wph2">
              <span className="relative flex h-2 w-2" data-id="element-105" data-mp="2z2zr8a1dk4ol">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-kitty-yellow-500 opacity-75" data-id="element-106" data-mp="2z5lz6as6gm7c" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-kitty-yellow-500" data-id="element-107" data-mp="383xmo3xqz3vk" />
              </span>
              UK Early Access — Limited Spots
            </motion.div>

            {/* Headline */}
            <h1 className="text-[2rem] sm:text-[2.5rem] lg:text-5xl xl:text-6xl font-extrabold text-kitty-dark leading-[1.1] mb-6 lg:mb-6 tracking-tight" data-id="element-108" data-mp="1dpd8ma3xm6l5">
              Shared expenses, made simple
            </h1>

            {/* Subheading */}
            <p className="text-lg lg:text-xl font-medium text-gray-700 mb-5 leading-relaxed max-w-md" data-id="element-109" data-mp="38vfmsxs6qdzv">
              KittyPot helps groups track shared expenses, split costs fairly,
              and see the simplest way to settle up.
            </p>

            <div className="max-w-md mb-7 rounded-2xl border border-kitty-yellow-200 bg-white px-4 py-3.5 shadow-sm" data-id="element-110" data-mp="3mtcjrvajwmf2">
              <div className="flex items-start gap-3" data-id="element-111" data-mp="3rre56mvg8xtp">
                <div className="mt-0.5 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-xl bg-kitty-yellow text-kitty-dark" data-id="element-112" data-mp="lmg7qterr8h">
                  <Link2Icon className="h-4 w-4" aria-hidden="true" data-id="element-113" data-mp="5dxg4to5fd11" />
                </div>
                <p className="text-sm sm:text-base font-bold leading-snug text-kitty-dark" data-id="element-114" data-mp="aanvtfw1k6lx">
                  Friends join with one tap in their browser, no download, no sign-up. Just open the link.
                </p>
              </div>
            </div>

            {/* Supporting copy */}
            <p className="text-base text-gray-500 mb-8 lg:mb-10 leading-relaxed max-w-md" data-id="element-115" data-mp="23uodszdqzxvf">
              Create a kitty for a trip, meal, house share, event or night out.
              Add expenses, choose who they're shared with, and let KittyPot
              work out who pays who.
            </p>

            {/* CTA */}
            <div className="flex flex-col sm:flex-row gap-4 mb-6" data-id="element-116" data-mp="1pw7zam9n932q">
              <button onClick={() => {
              document.getElementById('waitlist')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="w-full sm:w-auto bg-kitty-yellow hover:bg-kitty-yellow-500 text-kitty-dark px-8 py-[16px] lg:py-4 min-h-[56px] rounded-full font-bold transition-all active:scale-[0.98] shadow-lg hover:shadow-xl flex items-center justify-center gap-2 text-base" data-id="element-117" data-mp="2ml5sw15nquyb">
                Join the waitlist
              </button>
              <button onClick={() => {
              document.getElementById('how-it-works')?.scrollIntoView({
                behavior: 'smooth'
              });
            }} className="w-full sm:w-auto bg-white hover:bg-gray-50 text-kitty-dark px-8 py-[16px] lg:py-4 min-h-[56px] rounded-full font-bold transition-all active:scale-[0.98] border border-gray-200 shadow-sm flex items-center justify-center gap-2 text-base" data-id="element-118" data-mp="31hn50ulo8dlx">
                See how it works
              </button>
            </div>

            <p className="mb-5 max-w-md text-xs text-gray-500" data-id="element-119" data-mp="34q4xit1w2127">
              By joining you agree to our{' '}
              <a href="/privacy-policy" className="font-semibold text-kitty-dark underline underline-offset-2 transition-colors hover:text-kitty-yellow-700" data-id="element-120" data-mp="38si3nikjs0zi">
                Privacy Policy
              </a>
              .
            </p>
          </motion.div>

          {/* Right Column: App Mockup */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          rotate: 2
        }} animate={{
          opacity: 1,
          scale: 1,
          rotate: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2,
          type: 'spring'
        }} className="relative mx-auto w-full max-w-[240px] sm:max-w-[260px] lg:max-w-[320px] mt-8 lg:mt-0" data-id="element-121" data-mp="3nohhzay92xd3">
            {/* Floating expense-entry cue */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.5,
            y: 10
          }} animate={{
            opacity: 1,
            scale: 1,
            y: 0
          }} transition={{
            delay: 1.6,
            duration: 0.4,
            type: 'spring',
            stiffness: 200
          }} className="absolute -top-3 -right-4 z-30 bg-kitty-yellow text-kitty-dark text-sm font-bold px-3.5 py-1.5 rounded-full shadow-lg" data-id="element-122" data-mp="fhkm75ans8c5">
              Add an expense
            </motion.div>

            {/* Floating group cue */}
            

            <div className="overflow-hidden rounded-[2.25rem] border-[5px] border-kitty-dark bg-kitty-dark shadow-2xl" data-id="element-123" data-mp="182u903pv78nj">
              <img src="https://cdn.magicpatterns.com/uploads/cq3ZaRcmXLpAfBSFwp4C3c/WhatsApp_Image_2026-08-13_at_19.06.02_(1).jpg" alt="KittyPot app screen for a Ski Trip kitty, showing total spent, the people sharing the kitty, and controls to add an expense or receipt" className="block h-auto w-full" data-id="element-124" data-mp="134ss9pfwvlf8" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}